//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/loginPage/main/lan/es';
import createEditTemplate from 'Modules/loginPage/main/.components/createEditTemplate/lan/es';
import uploadImage from 'Modules/loginPage/main/.components/uploadImage/lan/es';

locales = {
    ...locales,
    ...main,
    ...createEditTemplate,
    ...uploadImage,
};

export default locales;